import { schema } from 'normalizr'

const tableOrderItemOption = new schema.Entity('tableOrderItemOptions')

export default tableOrderItemOption
